var render, staticRenderFns
import script from "./DescriptionListItem.vue?vue&type=script&lang=tsx&"
export * from "./DescriptionListItem.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce9ef9c",
  null
  
)

export default component.exports